import { clsx } from 'clsx';
import type { ReactNode } from 'react';

export type PageProps = {
  children: ReactNode;
  /** 'wide' (default) for tables/boards, 'narrow' for forms and settings. */
  width?: 'wide' | 'narrow' | 'full';
  className?: string;
};

const WIDTHS = { wide: 'max-w-[1600px]', narrow: 'max-w-4xl', full: 'max-w-none' } as const;

/** Standard page container: consistent padding and max width inside the app shell. */
export function Page({ children, width = 'wide', className }: PageProps) {
  return <div className={clsx('mx-auto flex w-full flex-col gap-5 px-4 py-5 sm:px-6', WIDTHS[width], className)}>{children}</div>;
}
